import { url } from "./server"
export const API = `${url}/api`